import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {WorkingTimeSchemaDetailComponent} from './working-time-schema-detail/working-time-schema-detail.component';
import {WorkingTimeSchemaDaysComponent} from './working-time-schema-days/working-time-schema-days.component';
import {WorkingTimeSchemaHoursComponent} from './working-time-schema-hours/working-time-schema-hours.component';
import {WorkingTimeSchemaCalendarComponent} from './working-time-schema-calendar/working-time-schema-calendar.component';
import {WorkingTimeSchemaComponent} from './working-time-schema.component';
import {SharedModule} from '../../shared/shared.module';
import {WorkingTimeSchemaService} from './working-time-schema.service';
import {WorkingTimeSchemaViewerComponent} from './working-time-schema-viewer/working-time-schema-viewer.component';
import { WORKING_TIME_SCHEMA_REDUCER } from './store/reducers/feature.reducers';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { calendarsEffects } from './store/effects/calendars.effects';
import { TimeDetailsComponent } from './working-time-schema-hours/time-details/time-details.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

const effects_working_time_schema = [calendarsEffects];
@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forFeature('workingTimeSchema', WORKING_TIME_SCHEMA_REDUCER),
    EffectsModule.forFeature(effects_working_time_schema),
    SharedModule,
    CommonModule,
    FormsModule
  ],
  declarations: [
    WorkingTimeSchemaComponent,
    WorkingTimeSchemaDetailComponent,
    WorkingTimeSchemaDaysComponent,
    WorkingTimeSchemaHoursComponent,
    WorkingTimeSchemaCalendarComponent,
    WorkingTimeSchemaViewerComponent,
    TimeDetailsComponent
  ],
  exports: [
    WorkingTimeSchemaComponent
  ],
  providers: [WorkingTimeSchemaService]
})
export class WorkingTimeSchemaModule { }
